










































/**
 * External dependencies.
 */
import Component, { mixins } from 'vue-class-component'
import { Prop, Watch } from 'vue-property-decorator'
/**
 * Internal dependencies.
 */
import { Modes } from '@/store/common/enum/Modes'
import { namespace as commonModule } from '@/store/common'

import PhotosHelperMixin from '@/mixins/PhotosHelperMixin.vue'
import IsotopeMixin from '@/mixins/IsotopeMixin.vue'
import CyclingAds from '@/components/ui/CyclingAds.vue'

@Component({
  components: {
    CyclingAds
  }
})
export default class ContestPhotos extends mixins(PhotosHelperMixin, IsotopeMixin) {
  @Prop(Array) contestPhotos!: Array<any> | object
  @Prop(Array) adsForSlides!: Array<any>

  photos: any = []
  page: number = 1
  batchIsLoaded: boolean = false
  isHover: any = null
  isFirefox: boolean = false
  cacheIndex: any = []

  @commonModule.Getter getMode: Modes

  get cycleOpen () {
    return this.getMode === Modes.OPEN
  }

  @Watch('contestPhotos')
  onPhotosPropChange (value: object, oldValue: any) {
    // this.photos = this.contestPhotos // NO! this is overwrite all loaded images
    this.renderImages(this.contestPhotos)
  }

  created () {
    this.container = document.querySelector('.isotope-section')
  }

  // method to batch load images
  renderImages (photos: any) {
    let countLoadedImagesInBatch: number = 0

    photos.forEach((photo: any, key: any) => {
      let loadImg = new Image()
      loadImg.onload = () => {
        // check if all images were loaded
        if (++countLoadedImagesInBatch === photos.length) {
          // append images
          this.photos = this.photos.concat(photos)

          // check if ->initial page load
          if (this.page === 1) {
            void this.initLayout()
          } else {
            void this.relayoutGrid(this.page)
          }

          setTimeout(() => {
            this.page++
            this.$emit('loading', false)
            this.batchIsLoaded = true
          }, 1000)
        }
      }
      // Firefox specific fix: for cache related bug
      if (navigator.userAgent.toLowerCase().indexOf('firefox') > -1) {
        this.isFirefox = true

        // maybe change randomization implementation later
        let randoString = Math.random().toString(36).substr(2, 5)
        // let randoNum = Math.floor(Math.random() * 1000)
        this.cacheIndex.push(randoString)

        loadImg.src = `${photo.urls.small}?cache=${randoString}`
      } else {
        // trigger browser render
        loadImg.src = photo.urls.small
      }
    })
  }
}
